// export const APP_VERSION = 'green'; // blue & green
export const VERSION_KEY = 'otterbrick-ver';
